@if (localizationInfo && VendorId) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <app-vendor-edit
          [vendorForm]="VendorFormGroup"
          [streetAddressForm]="VendorFormGroup.controls['StreetAddress']"
          [mailingAddressForm]="VendorFormGroup.controls['MailingAddress']"
          [remitToAddressForm]="VendorFormGroup.controls['RemitToAddress']"
          [localizationInfo]="localizationInfo"
          [selectedSmallBusinessOptionsFormArray]="
            selectedSmallBusinessOptionsFormArray
          "
          [VendorId]="VendorId"
          [ClientCompanyVendorMap]="ClientCompanyVendorMap"
          [CompanyIdToCompanyOfficesMap]="CompanyIdToCompanyOfficesMap"
          [OperatingStatesForm]="OperatingStatesForm"
        ></app-vendor-edit>
      </div>
    </div>
    <div class="row">
      <div class="offset-6 col-3">
        <button class="btn btn-secondary" (click)="close()">Cancel</button>
      </div>
      <div class="col-3">
        <button class="btn btn-primary" (click)="save()">Save</button>
      </div>
    </div>
  </div>
}
